// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1LSPH","inputWrap":"Table_inputWrap__2-R1F","col":"Table_col__2Njik","bmiTooltip":"Table_bmiTooltip__1uIfb"};